// import { getLatestWordPressAnnouncements } from "../api/wordpressAnnouncements.api";
// import { mapWordPressPostToAnnouncement } from "../utils/announcementMapper";

// export const getLatestAnnouncements = async ({
//   limit = 1,
//   categoryId,
//   signal,
// } = {}) => {
//   const posts = await getLatestWordPressAnnouncements({
//     limit,
//     categoryId,
//     signal,
//   });

//   return posts.map(mapWordPressPostToAnnouncement);
// };

// import { getLatestWordPressAnnouncements } from "../api/wordpressAnnouncements.api";
// import { mapWordPressPostToAnnouncement } from "../utils/announcementMapper";


// export const getLatestAnnouncements = async ({
//   limit = 1,
//   categorySlug = "ogloszenia",
//   signal,
// } = {}) => {
//   const posts = await getLatestWordPressAnnouncements({
//     limit,
//     categorySlug,
//     signal,
//   });

//   return posts.map(mapWordPressPostToAnnouncement);
// };

import {
  getLatestWordPressAnnouncements,
  getWordPressAnnouncementById
} from "../api/wordpressAnnouncements.api";

import {
  mapWordPressPostToAnnouncement
} from "../utils/announcementMapper";


export const getLatestAnnouncements = async ({
  limit = 1,
  categorySlug = "ogloszenia",
  signal,
} = {}) => {
  const posts = await getLatestWordPressAnnouncements({
    limit,
    categorySlug,
    signal,
  });

  return posts.map(mapWordPressPostToAnnouncement);
};


export const getAnnouncementById = async ({
  postId,
  signal,
}) => {
  const post = await getWordPressAnnouncementById({
    postId,
    signal,
  });

  return mapWordPressPostToAnnouncement(post);
};